export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8888.7bfba89d.jpg";